/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const SET_ROLE_SEARCH_VALUE = 'SET_ROLE_SEARCH_VALUE';
export const GET_ROLES = 'GET_ROLES';
export const SET_NO_ROLES = 'SET_NO_ROLES';
export const GET_ROLE_OF_SUBJECT = 'GET_ROLE_OF_SUBJECT';
export const SET_SELECTED_ROLE = 'SET_SELECTED_ROLE';
export const SET_FILTERED_ROLES = 'SET_FILTERED_ROLES';
export const RESET_ROLES = 'RESET_ROLES';
export const SET_DATA_PLATFORM_ACTIONS = 'SET_DATA_PLATFORM_ACTIONS';
export const EXPORT_ROLES_REQUEST = 'EXPORT_ROLES_REQUEST';
export const EXPORT_ROLES_SUCCESS = 'EXPORT_ROLES_SUCCESS';
export const EXPORT_ROLES_FAILURE = 'EXPORT_ROLES_FAILURE';
